#import "../../../graphql/fragments/coordinates-fragment.graphql"
#import "../../../graphql/fragments/location-weather-fragment.graphql"
#import "../../../../core-entity/graphql/fragments/widget-fragment.graphql"
#import "../../../graphql/fragments/creator-user-fragment.graphql"
#import "../../../graphql/fragments/peep-tag-maps-fragment.graphql"
#import "../../../../core-entity/graphql/fragments/header-field-fragment.graphql"

fragment AccountPageFragment on Account {
    id
    isDeleted
    name
    description
    avatarUrl
    hasUploadedAvatar
    canDeleteAvatar
    employeeCount
    revenue {
        currencyValue {
            amount
        }
    }
    territory {
        id
        name
    }
    industry {
        id
        name
    }
    accountType {
        id
        name
    }
    parentAccount {
        id
        name
        htmlUrlPath
    }
    childAccounts(first: 1000) {
        totalCount
    }
    createdTime
    creatorUser {
        ...CreatorUserFragment
    }
    owner {
        id
    }
    workspaceWidgets {
        ...WidgetFragment
    }
    sidebarWidgets {
        ...WidgetFragment
    }
    headerFields {
        ...HeaderFieldFragment
    }
    postalAddresses {
        primary {
            location {
                coordinates {
                    ...CoordinatesFragment
                }
                weather {
                    ...LocationWeatherFragment
                }
            }
        }
    }
    ...PeepTagMapsFragment
}
